import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Item from './Item';
import ExcessDetails from './ExcessDetails';
import ExistingFaultDetails from './ExistingFaultDetails';

const MotorBreakdownDetails = ({ details: {
  cover_type = false,
  number_of_callouts = false,
  age_of_vehicle = false,
  vehicle_registration = false,
  make = false,
  model = false,
  colour = false,
  registered_owner = false,
  first_registered_date_year = false,
  first_registered_date_month = false,
  existing_fault = false,
  details = null,
  claim_in_initial_period = false,
  excess_initial_amount = false,
  claim_initial_period_days = false,
  excess_normal_amount = false,
}}) => (
  <Fragment>
    <div style={{
      display: 'block',
      marginBottom: '20px',
      fontWeight: 'bold'
    }}>NO CLAIMS WITHIN FIRST 72 HOURS</div>
    { cover_type && (
      <Item key="cover_type" heading="Cover Type" content={cover_type} />
    )}
    { number_of_callouts && (
      <Item key="number_of_callouts" heading="Number Of Callouts" content={number_of_callouts} />
    )}
    { age_of_vehicle && (
      <Item key="age_of_vehicle" heading="Age Of Vehicle" content={`${age_of_vehicle} years`} />
    )}
    { vehicle_registration && (
      <Item key="vehicle_registration" heading="Vehicle Registration" content={vehicle_registration} />
    )}
    { make && (
      <Item key="make" heading="Vehicle Make" content={make} />
    )}
    { model && (
      <Item key="model" heading="Vehicle Model" content={model} />
    )}
    { colour && (
      <Item key="colour" heading="Vehicle Colour" content={colour} />
    )}
    { registered_owner && (
      <Item key="registered_owner" heading="Registered Owner" content={registered_owner} />
    )}
    { first_registered_date_year && first_registered_date_month && (
      <Item key="first_registered" heading="First Registered" content={`${first_registered_date_month}/${first_registered_date_year}`} />
    )}
    <br />
    <ExcessDetails
      claimInInitialPeriod={claim_in_initial_period}
      excessInitialAmount={excess_initial_amount}
      claimInitialPeriodDays={claim_initial_period_days}
      excessNormalAmount={excess_normal_amount}
    />
    <ExistingFaultDetails existingFault={existing_fault} details={details} />
  </Fragment>
);

MotorBreakdownDetails.propTypes = {
  details: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default MotorBreakdownDetails;



// WEBPACK FOOTER //
// ./src/components/Query/QueryShow/MotorBreakdownDetails.js